// Central marketplace config: display names, deep-link builders, and the
// category -> recommended channels map. Keeps StrategyCard, ListingGenerator
// and the backend in sync on which platforms fit each product category.

export const MARKETPLACE_META = {
  subito: { name: "Subito", url: () => "https://inserimento.subito.it/" },
  ebay: { name: "eBay", url: (title) => `https://www.ebay.it/sl/sell?mode=AddItem&title=${encodeURIComponent(title || "")}` },
  facebook: { name: "FB Marketplace", url: () => "https://www.facebook.com/marketplace/create/item" },
  vinted: { name: "Vinted", url: () => "https://www.vinted.it/items/new" },
  wallapop: { name: "Wallapop", url: () => "https://it.wallapop.com/app/catalog/upload" },
  vestiaire: { name: "Vestiaire Collective", url: () => "https://www.vestiairecollective.com/sell-clothes-online/" },
  depop: { name: "Depop", url: () => "https://www.depop.com/sell/" },
  autoscout24: { name: "AutoScout24", url: () => "https://www.autoscout24.it/inserisci-annuncio/" },
};

const GROUPS = {
  vehicles: ["subito", "autoscout24", "facebook"],
  fashion: ["vinted", "wallapop", "vestiaire", "depop"],
  electronics: ["subito", "ebay", "wallapop", "facebook"],
  pc_components: ["subito", "ebay", "facebook"],
  home: ["subito", "facebook", "ebay"],
  default: ["subito", "ebay", "facebook"],
};

export const getMarketplaces = (category) => {
  const c = category || "";
  if (c === "vehicle_escooter" || c === "vehicle_parts") return GROUPS.electronics;
  if (c.startsWith("vehicle_")) return GROUPS.vehicles;
  if (["clothing", "shoes", "bags_accessories", "jewelry", "kids_clothing", "sport_apparel"].includes(c)) return GROUPS.fashion;
  if (c === "electronics_pc_components") return GROUPS.pc_components;
  if (c.startsWith("electronics_")) return GROUPS.electronics;
  if (["furniture", "home", "diy_tools"].includes(c) || c.startsWith("appliance_")) return GROUPS.home;
  return GROUPS.default;
};

export const marketplaceName = (key) => MARKETPLACE_META[key]?.name || key;
